import React, { FC } from 'react';

import { Button } from 'evergreen-ui';
import { FiLogOut } from 'react-icons/fi';
import { useAuthenticator } from '@aws-amplify/ui-react';

export const SignOutButton: FC = () => {
  const { authStatus, signOut } = useAuthenticator(context => [context.authStatus]);
  if (authStatus !== 'authenticated') return null;

  return (
    <Button height={24} onClick={() => signOut()} iconBefore={<FiLogOut />}>
      Sign out
    </Button>
  );
};
